<template>
  <div class="float-whatsapp">
    <v-container class="pa-0">
      <v-sheet
        class="float-whatsapp-buttons"
        width="100%"
        :height="smAndDown ? `83px` : `64px`"
        color="#1AA364"
      >
        <v-menu
          v-for="({ title, contacts }, i) in stores"
          :key="`${title}-${i}`"
          offset-y
          top
          :close-on-content-click="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="
                float-whatsapp-buttons-item
                text-none text-sm-h6 text-caption
              "
              height="100%"
              text
            >
              <div
                class="
                  d-flex
                  flex-column flex-md-row
                  align-center
                  justify-center
                "
              >
                <v-icon :size="smAndDown ? 30 : 22" color="white">
                  fab fa-whatsapp</v-icon
                >
                <span class="white--text open-sans ml-md-2">{{ title }}</span>
              </div>
            </v-btn>
          </template>
          <v-list class="float-whatsapp-menu" dense>
            <v-list-item
              v-for="({ phone, label, whatsappLink }, j) in contacts"
              :key="`${title}-${phone}-${j}`"
              :href="whatsappLink"
              target="_blank"
            >
              <v-list-item-icon class="mr-3 my-2">
                <v-icon color="#1AA364" size="20">fab fa-whatsapp</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="open-sans font-weight-bold">
                  {{ label }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { getStoreWhatsappContacts } from "../utils/storeWhatsappContacts";

export default {
  computed: {
    stores() {
      return this.$rest("stores").list.map((store) => ({
        title: store.title,
        contacts: getStoreWhatsappContacts(store),
      }));
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.float-whatsapp {
  left: 0;
  right: 0;
  position: fixed;
  bottom: 10px;
  z-index: 10;
  @media (max-width: 960px) {
    bottom: 0;
  }

  &-buttons {
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2),
      0px 6px 10px 4px rgba(0, 0, 0, 0.1);
    border-radius: 64px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    @media (max-width: 960px) {
      border-radius: 0 !important;
    }
    &-item {
      border-radius: 64px !important;

      @media (max-width: 960px) {
        border-radius: 0 !important;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
}

.float-whatsapp-menu {
  min-width: 240px;
}
</style>
